var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.number,
        title: _vm.$t("DELETE_NUMBER_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("DELETE_NUMBER_MODAL_CANCEL_ACTION"),
        "confirm-action-text": _vm.$t("DELETE_NUMBER_MODAL_CONFIRM_ACTION"),
        "show-confirm-button": !!_vm.numberReferences,
        "show-cancel-button": !!_vm.numberReferences,
        "on-confirm": _vm.onConfirm
      },
      on: {
        confirm: _vm.confirmDelete,
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      !_vm.numberReferences
        ? _c("div", [
            _c(
              "div",
              [
                _vm.isLoading ? _c("Loader") : _vm._e(),
                _vm._v(" "),
                _c("i18n", {
                  attrs: { path: _vm.loadingTextKey, tag: "span" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "items",
                        fn: function() {
                          return [
                            _c("strong", { staticClass: "f-s-13" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "DELETE_NUMBER_MODAL_NUMBER_CHECK_ASSOCIATION_ITEMS"
                                  )
                                )
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3181370905
                  )
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.numberReferences && !_vm.numberReferences.hasReferences
        ? _c("p", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "DELETE_NUMBER_MODAL_NUMBER_NONE_ASSOCIATION_TEXT",
                expression: "'DELETE_NUMBER_MODAL_NUMBER_NONE_ASSOCIATION_TEXT'"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.numberReferences && _vm.numberReferences.hasReferences
        ? _c("div", [
            _c(
              "p",
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("DELETE_NUMBER_MODAL_NUMBER_CONFIRM_QUESTION")
                    ) +
                    "\n      "
                ),
                _c("br"),
                _vm._v(" "),
                _c("i18n", {
                  attrs: {
                    path: "DELETE_NUMBER_MODAL_NUMBER_ASSOCIATION_TEXT",
                    tag: "span"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "phoneNumber",
                        fn: function() {
                          return [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.number.displayNumber))
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2604650175
                  )
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
              _c("div", { staticClass: "form-horizontal" }, [
                _vm.numberReferences.campaignId
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN",
                              expression: "'CAMPAIGN'"
                            }
                          ]
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("p", { staticClass: "form-control-static" }, [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right.hover",
                                  value: _vm.$t("VIEW_CAMPAIGN_TEXT"),
                                  expression: "$t('VIEW_CAMPAIGN_TEXT')",
                                  modifiers: { right: true, hover: true }
                                }
                              ],
                              attrs: {
                                href: _vm.getHref("dashboard.campaign", {
                                  campaignId: _vm.numberReferences.campaignId
                                }),
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.numberReferences.campaignName) +
                                  "\n                "
                              ),
                              _c("i", {
                                staticClass: "fa fa-external-link m-l-5"
                              })
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.numberReferences.affiliateId
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "PUBLISHER",
                              expression: "'PUBLISHER'"
                            }
                          ]
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("p", { staticClass: "form-control-static" }, [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right.hover",
                                  value: _vm.$t(
                                    "DELETE_NUMBER_MODAL_VIEW_PUBLISHER"
                                  ),
                                  expression:
                                    "$t('DELETE_NUMBER_MODAL_VIEW_PUBLISHER')",
                                  modifiers: { right: true, hover: true }
                                }
                              ],
                              attrs: {
                                href: _vm.getHref("dashboard.affiliate.edit", {
                                  affiliateId: _vm.numberReferences.affiliateId
                                }),
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.numberReferences.affiliateName) +
                                  "\n                "
                              ),
                              _c("i", {
                                staticClass: "fa fa-external-link m-l-5"
                              })
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.numberReferences.numberpoolId
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "NUMBERS_LINK_POOL",
                              expression: "'NUMBERS_LINK_POOL'"
                            }
                          ]
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("p", { staticClass: "form-control-static" }, [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right.hover",
                                  value: _vm.$t(
                                    "DELETE_NUMBER_MODAL_VIEW_PUBLISHER"
                                  ),
                                  expression:
                                    "$t('DELETE_NUMBER_MODAL_VIEW_PUBLISHER')",
                                  modifiers: { right: true, hover: true }
                                }
                              ],
                              attrs: {
                                href: _vm.getHref("dashboard.numberpool.edit", {
                                  numberPoolId:
                                    _vm.numberReferences.numberpoolId
                                }),
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.numberReferences.numberpoolName) +
                                  "\n                "
                              ),
                              _c("i", {
                                staticClass: "fa fa-external-link m-l-5"
                              })
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }